module.exports = __webpack_public_path__ + "static/media/rehau_60.2fdd3f78.png";